import { render, staticRenderFns } from "./OracleChart.vue?vue&type=template&id=3b150048&scoped=true&"
import script from "./OracleChart.vue?vue&type=script&lang=js&"
export * from "./OracleChart.vue?vue&type=script&lang=js&"
import style0 from "./OracleChart.vue?vue&type=style&index=0&id=3b150048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b150048",
  null
  
)

component.options.__file = "OracleChart.vue"
export default component.exports